import { SvgIcon } from '@mui/material'
import { SvgIconProps } from '@mui/material/SvgIcon'

export const Share = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5858 5H14V3H20H21V4V10H19V6.41423L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L17.5858 5ZM7 5.00001C5.89543 5.00001 5 5.89545 5 7.00001V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V13.1111H21V17C21 19.2092 19.2091 21 17 21H7C4.79086 21 3 19.2092 3 17V7.00001C3 4.79088 4.79086 3.00001 7 3.00001H10.8889V5.00001H7Z"
      fill="currentColor"
    />
  </SvgIcon>
)
